
import React from 'react';
import {Tabs} from 'antd';
// import DcpOrderConfirmList from './DcpOrderConfirmList.js';
import SecretOrderConfirmDetail from '../SecretOrderConfirm/SecretOrderConfirmDetail.js'
import SecretOrderConfirmList from '../SecretOrderConfirm/SecretOrderConfirmList.js'
const { TabPane } = Tabs;
class DcpOrderConfirm extends React.Component{
  
    constructor(props) {
      super(props);  
      this.state={
        activeKey:"1",
        sign:'2'
      }
    }
      callback(activeKey,type,params){
          if(type == "details"){
            this.state.params = params
            console.log(params)
          }
          if(type == "add"){
            this.state.params = null
          }
        this.setState({activeKey:activeKey})
      }
    render(){
        return(
          <div>
            <Tabs type="card" activeKey={this.state.activeKey} onChange= {this.callback.bind(this)}>
            <TabPane tab="已确定DCP列表" key="1">
              <SecretOrderConfirmList  buttonList={this.props.buttonList} callback = {this.callback.bind(this)} sign={this.state.sign}/>
            </TabPane>
            <TabPane tab="已确定DCP详情" key="2">
            < SecretOrderConfirmDetail buttonList={this.props.buttonList} params = {this.state.params} callback = {this.callback.bind(this)}/>
            </TabPane>
          </Tabs>
          </div>
        )
    }
}
export default DcpOrderConfirm;
